import { FC, PropsWithChildren } from 'react';

import { FormConfigItem, RequisiteName, RequisitesFieldName, RequisitesFormName } from 'utils/constants/requisites';

import { Card, useBreakpoint } from '@hh.ru/magritte-ui';

import { RequisitesFormTitle } from 'components/RequisitesFormModal/RequisitesFormTitle/RequisitesFormTitle';
import { RequisitesItem } from 'components/RequisitesFormModal/RequisitesItem/RequisitesItem';
import { RequisitesPayersSelect } from 'components/RequisitesFormModal/RequisitesPayersSelect/RequisitesPayersSelect';

import styles from 'components/RequisitesFormModal/RequisitesForm/RequisitesForm.module.less';

interface PartRequisitesFormProps {
    isDisabledField: (fieldName: RequisiteName | RequisitesFieldName) => boolean;
    title: string;
    subtitle: string;
    showPayersSelect?: boolean;
    config: FormConfigItem[];
    requisiteFormName: RequisitesFormName;
}

const RequisitesFormWrapper: FC<PropsWithChildren> = ({ children }) => (
    <Card borderRadius={24} padding={24} stretched borderWidth="default">
        {children}
    </Card>
);

export const RequisitesForm: FC<PartRequisitesFormProps & PropsWithChildren> = ({
    isDisabledField,
    title,
    subtitle,
    showPayersSelect = false,
    config,
    requisiteFormName,
}) => {
    const { isMobile } = useBreakpoint();

    const content = (
        <div data-qa={requisiteFormName}>
            <RequisitesFormTitle title={title} subtitle={subtitle} />
            {showPayersSelect && <RequisitesPayersSelect />}
            <div className={styles.requisitesFormItemsContainer}>
                {config.map((item) => {
                    const fieldName = item.fieldName;
                    return (
                        <RequisitesItem
                            key={fieldName}
                            isFieldDisabled={isDisabledField(fieldName)}
                            requisiteFormName={requisiteFormName}
                            {...item}
                        />
                    );
                })}
            </div>
        </div>
    );

    return <>{isMobile ? content : <RequisitesFormWrapper>{content}</RequisitesFormWrapper>}</>;
};
